import React from "react";

const PictureDisplay = ({ src, srcset, viewWidth, id, style, className, alt }, ref) => {
    return (
        <picture>
            <source
                type={"image/webp"}
                srcSet={srcset}
                sizes={viewWidth ?? "100vw"}
            />
            <img src={src} id={id} ref={ref} style={style} className={className} alt={alt} />
        </picture>
    );
}

export default React.forwardRef(PictureDisplay)